import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { gettext } from "web/script/modules/django-i18n";
import { SizePropType } from "web/types/buy-option";
import styles from "./size-picker.css";

function Size(_ref) {
  var size = _ref.size;
  var inStock = size.stock_status === 3;
  var label = size.label;
  return React.createElement("li", {
    className: styles.size
  }, React.createElement("span", {
    className: classnames(styles.sizeText, _defineProperty({}, styles.oos, !inStock)) // "Unavailable"
    ,
    "aria-label": inStock ? label : "".concat(label, " ").concat(gettext("in_stock_product.sizes.unavailable_aria_label"))
  }, label));
}

Size.propTypes = {
  size: SizePropType.isRequired
};

function SizePicker(_ref2) {
  var allSizesSorted = _ref2.allSizesSorted,
      buyOptionSizes = _ref2.buyOptionSizes;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var sizeArray = allSizesSorted.map(function (sizeKey) {
    return buyOptionSizes[sizeKey];
  }) // Only include sizes on this buy option (ones missing will be undefined, so filtered out)
  .filter(function (size) {
    return size;
  });
  return React.createElement("div", {
    className: styles.wrapper
  }, React.createElement("ul", {
    className: styles.sizes
  }, sizeArray && sizeArray.slice(0, 10).map(function (size) {
    return React.createElement(Size, {
      key: size.size_key,
      size: size
    });
  }), open && sizeArray.slice(10).map(function (size) {
    return React.createElement(Size, {
      key: size.size_key,
      size: size
    });
  })), sizeArray.length > 10 && React.createElement("button", {
    className: styles.more,
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, React.createElement("span", null, open ? gettext("general.see_less") : gettext("general.see_more"))));
}

SizePicker.propTypes = {
  buyOptionSizes: PropTypes.objectOf(SizePropType).isRequired,
  allSizesSorted: PropTypes.array
};
export default SizePicker;